import styled from 'styled-components'

import { COLOURS } from 'resources'
import PrimaryLink from 'units/PrimaryLink'

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`

export const ProfileContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ProfilePictureWrapper = styled.div``

export const ProfileContent = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  margin-left: 15px;
`

export const ProfileUserLabel = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${COLOURS.neutralBlack};
  cursor: pointer;
  word-break: break-word;
`

export const ProfileBalance = styled(PrimaryLink)`
  font-weight: 500;
  font-size: 16px;
  color: ${COLOURS.secondaryPurple1};
  cursor: pointer;
`
